import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  AgentsResponseModel,
  IAgentsResponse,
  IUpdateAgentPayload,
  IUpdateAgentResponse,
} from '../../shared/models/agents.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AgentsService {
  constructor(private readonly http: HttpClient) {}

  getAgents(siteId: number): Observable<IAgentsResponse> {
    return this.http
      .get<IAgentsResponse>(`${environment.agent_call_management_api_url}/api/v1/agents/${siteId}`)
      .pipe(map((response) => new AgentsResponseModel(response)));
  }

  assignAgentToCall(payload: IUpdateAgentPayload[]): Observable<IUpdateAgentResponse> {
    return this.http.post<IUpdateAgentResponse>(
      `${environment.agent_call_management_api_url}/api/v1/agents/agent-call-assignments`,
      payload,
    );
  }
}
